
const data = {
  name: "Rio Vo",
  title: "Software Developer",
  social: {
    github: "https://github.com/hoavo1490",
    email: "hoavo1490@gmail.com",
  },
  about: {
    title: "My Story",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ullamcorper porta pharetra. Nunc porta dui eu mattis laoreet. Quisque lobortis orci sagittis, luctus ligula nec, sagittis leo. Ut convallis eu mi dignissim facilisis. Donec egestas vitae sapien quis bibendum. Sed rhoncus aliquet felis, ac cursus dui varius sit amet. Etiam eu nisi ligula. Sed sagittis massa a metus pulvinar, eu vestibulum nulla molestie. Nullam luctus sit amet felis quis ullamcorper. ",
  },
  skills: [
    // {
    //   skillName: "Frontend",
    //   skillIcon: <FaCode className={BOOTSTRAP_FOR_SKILL_ICON} />,
    // },
    // {
    //   skillName: "Design/UX",
    //   skillIcon: <FaPalette className={BOOTSTRAP_FOR_SKILL_ICON} />,
    // },
    // {
    //   skillName: "ReactJS",
    //   skillIcon: <FaReact className={BOOTSTRAP_FOR_SKILL_ICON} />,
    // },
  ],
  projects: [
    // {
    //   title: "React tailwind portfolio",
    //   description: "👨‍🎨 An open-source portfolio template built with React and Tailwind.",
    //   tags: [
    //     "template",
    //     "portfolio",
    //     "reactjs",
    //     "tailwindcss"
    //   ],
    //   link: "https://github.com/braydentw/react-tailwind-portfolio"
    // },
    // {
    //   title: "My personal website",
    //   description: "⚡ My portfolio built with NextJS and TailwindCSS.",
    //   tags: [
    //     "website",
    //     "portfolio",
    //     "nextjs",
    //     "tailwindcss"
    //   ],
    //   link: "https://github.com/braydentW/braydentw"
    // }
  ]
};
export default data;
